/* @flow */

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';

export const TOGGLE_CHANGE_PASSWORD = 'TOGGLE_CHANGE_PASSWORD';
export const SHOW_CHANGE_PASSWORD_NOTIFICATION_SUCCESS =
  'SHOW_CHANGE_PASSWORD_NOTIFICATION_SUCCESS';

export const TOGGLE_DELETE_ACCOUNT = 'TOGGLE_DELETE_ACCOUNT';
